import { RenderConfiguration } from "./useRenderOnDemand.types";
import dataContainer from "../services/DataContainer";
import { useLocation, useParams } from "react-router";
import { DataContainerContext } from "../context/DataContainerContext";
import { useContext, useEffect, useState } from "react";
import { ConfiguratorOptions } from "../enum/enums";

const useRenderConfig = () => {
  const [selectedColor, setSelectedColor] = useState(dataContainer.getSelectedColorFromColorizer()?.original_key);
  const loadedProductId = dataContainer.getCurrentModelId();
  const configuration: Record<string, Record<string, string>> = {};
  const {activeComponentGroups} = useContext(DataContainerContext);
  const currentComponentGroup = activeComponentGroups.name;
  const category = (dataContainer.mLoadedData as any)?.category;
  const {modelName} = useParams();
  const {modelNameFromUrl} = useParams();

  const urlModelName = modelName || modelNameFromUrl;
  const currentProductName = urlModelName?.split("_")[0];
  const loadedData = dataContainer.mLoadedData as { id: number; name: string; product_info?: { description?: string } } | null;
  const loadedProductMatchesUrl = Boolean(
    loadedData &&
    urlModelName &&
    (loadedData.id >= 183 && loadedData.id < 188
      ? loadedData.name?.toLowerCase() === urlModelName
      : loadedData.product_info?.description === urlModelName)
  );
  const productId = loadedProductMatchesUrl ? loadedProductId : 0;
  const location = useLocation();

  const allComponents = dataContainer.getAllComponents()?.filter((component: { name: string; }) => component.name !== ConfiguratorOptions.CHASSI_TYPE);
  const selectedVariations = allComponents?.map((component: { name: any; id: number}) => dataContainer.findSelectedVariantByComponentNameAndComponentGroup(component.name, dataContainer.findComponentGroupByComponentId(component.id).name));

  useEffect(() => {
    setSelectedColor(dataContainer.getSelectedColorFromColorizer()?.original_key);
  }, [dataContainer.getSelectedVariations()]);
  
  const interiorSelectedVariations = selectedVariations && selectedVariations.filter((variant: any) => dataContainer.findComponentGroupByName(variant?.component_group_name)?.name === ConfiguratorOptions.INTERIOR);
  const exteriorSelectedVariations = selectedVariations && selectedVariations.filter((variant: any) => dataContainer.findComponentGroupByName(variant?.component_group_name)?.name !== ConfiguratorOptions.INTERIOR);

  let getOriginalKeysAndComponentNames;

  const mirrorsForInterior = dataContainer.findSelectedVariantByComponentNameAndComponentGroup(ConfiguratorOptions.MIRRORS, ConfiguratorOptions.EXTERIOR)?.original_key;
  const cabsForInterior = dataContainer.findSelectedVariantByComponentNameAndComponentGroup(ConfiguratorOptions.CABS, ConfiguratorOptions.EXTERIOR)?.original_key;

  if (currentComponentGroup === ConfiguratorOptions.INTERIOR && !location.pathname.includes("/summary")) {
    getOriginalKeysAndComponentNames = interiorSelectedVariations.map((el: { component_id: number; original_key: string; }) => {
      const componentName = dataContainer.findComponentById(el?.component_id)?.name;              
      return {
        originalKey: el?.original_key,
        componentName: componentName,
      };
    });
    configuration[ConfiguratorOptions.INTERIOR] = {};
    configuration[ConfiguratorOptions.INTERIOR][ConfiguratorOptions.MIRRORS] = mirrorsForInterior;
    configuration[ConfiguratorOptions.INTERIOR][ConfiguratorOptions.CABS] = cabsForInterior;
    getOriginalKeysAndComponentNames.forEach((singleKeyNamePair: { componentName: string | number; originalKey: string; }) => {              
      configuration[ConfiguratorOptions.INTERIOR][singleKeyNamePair.componentName] = singleKeyNamePair.originalKey;          
    });
  } else {
    getOriginalKeysAndComponentNames = exteriorSelectedVariations?.map((el: { component_id: number; original_key: string; }) => {
      const componentName = dataContainer.findComponentById(el?.component_id)?.name;              
      return {
        originalKey: el?.original_key,
        componentName: componentName,
      };
    });
    configuration[ConfiguratorOptions.EXTERIOR] = {};
    getOriginalKeysAndComponentNames?.forEach((singleKeyNamePair: { componentName: string | number; originalKey: string; }) => { 
      if (singleKeyNamePair.componentName === ConfiguratorOptions.COLORS && selectedColor) {
        configuration[ConfiguratorOptions.EXTERIOR][singleKeyNamePair.componentName] = selectedColor; 
      } else {
        if(category?.name === "Electric" && singleKeyNamePair.componentName === "Batteries") {
          return;
        } else if(category?.name === "Electric" && singleKeyNamePair.componentName === "Motors") {
          const transmissionAttribute = (dataContainer.mLoadedData as any)?.attribute_values?.find(
            (attr: any) => attr.attribute_name === "Transmission"
          );
          configuration[ConfiguratorOptions.EXTERIOR][ConfiguratorOptions.TRANSMISSIONS] = transmissionAttribute?.value || "i_shift";
          configuration[ConfiguratorOptions.EXTERIOR][ConfiguratorOptions.ENGINES] = singleKeyNamePair.originalKey;
          return;
        }
        configuration[ConfiguratorOptions.EXTERIOR][singleKeyNamePair.componentName] = singleKeyNamePair.originalKey;
      }
    });
  }
  
  const renderSpec: RenderConfiguration = {
    productId,
    componentGroups: loadedProductMatchesUrl ? configuration : {},
    productName: currentProductName?.toUpperCase()
  };
  
  return renderSpec;
};

export default useRenderConfig;